import { customFetchV2 } from "./fetch";
import { resolveFirebaseIdTokenForApiCall } from "./firebaseToken";

export interface UpdateStripeKeysParams {
  secretKey: string;
  paymentKey: string;
}

export async function updateStripeKeys(
  adminServiceUrl: string,
  charityId: string,
  token: string,
  params: UpdateStripeKeysParams
): Promise<void> {
  const resolved = await resolveFirebaseIdTokenForApiCall(token);
  const fullUrl = `${adminServiceUrl}/api/v1/${charityId}/stripe?token=${encodeURIComponent(
    resolved
  )}`;

  await customFetchV2({
    url: fullUrl,
    method: "POST",
    mode: "cors",
    body: JSON.stringify({
      secretKey: params.secretKey.trim(),
      paymentKey: params.paymentKey.trim(),
    }),
    headers: {
      "content-type": "application/json",
    },
  });
}
